export const getGraphCards = ({all_issues, current_issues, response_time, availability}) => {
    return [
        {
            id: 'all_issues',
            title: 'All issues',
            value: all_issues,
            activeClassName: 'gray',
        },
        {
            id: 'current_issues',
            title: 'Current issues',
            value: current_issues,
            activeClassName: 'red',
        },
        {
            id: 'response_time',
            title: 'Avg. response time',
            value: response_time,
            activeClassName: 'blue',
        },
        {
            id: 'availability',
            title: 'Availability',
            value: availability,
            activeClassName: 'green',
        },
    ];
};

export const chartOptions = {
    tooltips: {
        intersect: false,
        enabled: true,
        mode: 'label',
        backgroundColor: 'white',
        borderWidth: 1,
        borderColor: 'gray',
        titleFontColor: 'black',
        //bodyFontColor: 'black',
        displayColors: false,

        callbacks: {
            label: ((tooltipItems, data) => {
                let arr = [];
                arr.push(tooltipItems.value + ' ' + data.datasets[tooltipItems.datasetIndex].label);
                return arr;
            }),
            labelTextColor: (tooltipItems, data) => {
                if(data.config.data.datasets[tooltipItems.datasetIndex].yAxisID === 'all_issues') return '#636b6f';
                if(data.config.data.datasets[tooltipItems.datasetIndex].yAxisID === 'current_issues') return '#DC4B3E';
                //if(data.config.data.datasets[tooltipItems.datasetIndex].yAxisID === '') return '#3CBA54';
                return 'black';
            },
        }
    },
    hover: {
        intersect: false,
    },
    elements: {
        point: {
            radius: 0,
            hitRadius: 4,
            hoverRadius: 5,
            hoverBorderColor: "#C2C2C2",
            hoverBorderWidth: 2,
        },
    },
    responsive: true,
    maintainAspectRatio: false,
    hoverMode: 'index',
    stacked: false,
    legend: {
        display: false
    },
    layout: {
        padding: {
            top: 5,
        }
    },
    title: {
        display: false,
    },
    scales: {
        yAxes: [
            {
                type: 'linear',
                gridLines: {
                    display: true,
                },
                ticks: {
                    display: false,
                },
                id: 'all_issues',
            },{
                type: 'linear',
                display: false,
                id: 'current_issues',
            },{
                type: 'linear',
                display: false,
                id: 'response_time',
            },{
                type: 'linear',
                display: false,
                id: 'availability',
            }
        ],
        xAxes: [{
            gridLines: {
                display: false,
            },
            scaleLabel:{
                labelString: '',
            },
            ticks: {
                display: false,
                autoSkipPadding: 1000000,
                maxRotation: 0,
            }
        }]
    }
};
